import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ActionResultModel } from '../../../models/core/action-result.model';
import { ApiResponseModel } from '../../../models/core/api-response.model';
import { GeneralMeetingsResource } from '../../../services/resources/general-meetings.resource';

@Component({
    selector: 'sl-general-meeting-import-dialog',
    templateUrl: './general-meeting-import-dialog.component.html',
    styleUrls: ['./general-meeting-import-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralMeetingImportDialogComponent {
    hasStarted = false;
    hasFinished = false;
    isSuccessful = false;

    private fileBase64?: string;

    private readonly dialogRef = inject(MatDialogRef);
    private readonly generalMeetingsResource = inject(GeneralMeetingsResource);

    cancel(): void {
        this.dialogRef.close();
    }

    fileSelected(event: any): void {
        this.fileBase64 = undefined;
        const reader = new FileReader();

        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.fileBase64 = reader.result?.toString()?.split(',')?.at(1);
            };
        }
    }

    upload(): void {
        if (!!this.fileBase64) {
            this.hasStarted = true;
            this.generalMeetingsResource.importGeneralMeeting(this.fileBase64).subscribe({
                next: this.onUploadSuccess.bind(this),
                error: this.onUploadFailed.bind(this)
            });
        }
    }

    onUploadSuccess(result: ApiResponseModel<ActionResultModel>): void {
        this.hasFinished = true;
        this.isSuccessful = result.value.isSuccessful;
    }

    onUploadFailed(): void {
        this.hasFinished = true;
        this.isSuccessful = false;
    }
}
